module.exports = __webpack_public_path__ + "static/img/BR.471ea068.jpg";